module.exports = __webpack_public_path__ + "img/1.a99113c.png";